<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
    <div class="row mb-2">
        <div class="col p-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row mb-3" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <h4 class="mb-2 py-1 font-header-1">Verifications</h4>
</div>

<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class=" mb-2">
        <div class="col p-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body mt-2">
                    <div class="row">
                        <div class="col-lg-4 d-flex mb-2 mt-3">
                            <label class="label-font col-lg-4">Start Date</label>
                            <my-date-picker class="col" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                [selDate]="fromDate" (inputFieldChanged)="DateFormat($event,'inputchanged','FromDate')"
                                (dateChanged)="DateFormat($event,'datechanged','FromDate')">
                            </my-date-picker>
                        </div>
                        <div class="col-lg-4 d-flex mb-2 mt-3">
                            <label class="label-font col-lg-4 ">End Date</label>
                            <my-date-picker class="col" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                [selDate]="toDate" (inputFieldChanged)="DateFormat($event,'inputchanged','ToDate')"
                                (dateChanged)="DateFormat($event,'datechanged','ToDate')">
                            </my-date-picker>
                        </div>

                        <div class="col-lg-4  col-11 d-flex mb-2 mt-3">
                            <label class="label-font col-lg-4 col-4">Client</label>
                            <ng-select class="col" [searchable]="true" [clearable]="true" [items]="AllClientList"
                                bindLabel="Value" bindValue="Key" [(ngModel)]="verificationBO.clientId">
                            </ng-select>
                        </div>
                        <div *ngIf="activeTab == 'TimesheetVerification'" class="col-lg-4 col-11 d-flex mb-2 mt-3">
                            <label class="label-font col-lg-4 col-4">Employee</label>
                            <ng-select class="col" [searchable]="true" [clearable]="true" [items]="AllEmployeeList"
                                bindLabel="Value" bindValue="Key" [(ngModel)]="verificationBO.employeeId">
                            </ng-select>
                        </div>

                        <div class="col-lg-4 col-11 d-flex mb-2 mt-3">
                            <label class="label-font col-lg-4 col-4">Validation Status</label>
                            <ng-select class="col" [searchable]="true" [clearable]="true" [items]="validationStatusList"
                                bindLabel="Value" bindValue="Key" [(ngModel)]="verificationBO.status">
                            </ng-select>
                        </div>
                        <!-- <div class="col-lg-4 col-11 d-flex mb-2 mt-3" *ngIf="activeTab == 'CSGVerification'">
                            <label class="label-font col-lg-4 col-4">Bill Type</label>
                            <ng-select class="col" [searchable]="true" [items]="BillTypeList"
                                bindLabel="Value" bindValue="Key" [(ngModel)]="verificationBO.billType">
                            </ng-select>
                        </div> -->
                        <div class="col-lg-4 col-11 mt-3" >
                            <input type="radio" class="ms-5" name="all" value="All"
                            [(ngModel)]="ApproveFilter" (change)="apply()"> &nbsp; All
                        <input type="radio" class="ms-1" name="all" value="Approve"
                            [(ngModel)]="ApproveFilter" (change)="apply()"> &nbsp;Approved
                        <input type="radio" class="ms-1" name="all" value="NotApprove"
                            [(ngModel)]="ApproveFilter" (change)="apply()"> &nbsp; Not
                        Approved

                        </div>
                    </div>

                    <div class="row">
                        <div class="col  mt-2">
                            <div class="text-end">
                                <button type="button" class="btn btn-sm" (click)="apply()">Apply
                                </button>
                                <button type="button" class="btn btn-sm ms-lg-5 ms-2" (click)="refresh()">Refresh
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class="mb-2">
        <div class="col p-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-header transparent text-muted">
                    <div class="mb-3 text-end">
                        <button type="button" class="btn btn-sm" (click)="selecttobill()"
                            *ngIf="fp.timesheetversendtobill && activeTab == 'TimesheetVerification' && fromClaim.from != 'Claim'"
                            [disabled]="sendToBillinProgress || selectedtimesheets?.length == 0 || global.checkProgressTimesheet">Send
                            To Bill
                        </button>
                        <button type="button" class="btn btn-sm" (click)="selecttobill()"
                            *ngIf="fp.transactionversendtobill && activeTab == 'TransactionVerification' && fromClaim.from != 'Claim'"
                            [disabled]="sendToBillinProgress || selectedtransactions?.length == 0 || global.checkProgressTransaction">Send
                            To
                            Bill
                        </button>
                        <button type="button" class="btn btn-sm" (click)="selecttobill()"
                            *ngIf="fp.purchasereqversendtobill && activeTab == 'PurchseVerification' && fromClaim.from != 'Claim'"
                            [disabled]="sendToBillinProgress || selectedpurchases?.length==0 || global.checkProgressPurchase">Send
                            To Bill
                        </button>
                        <button type="button" class="btn btn-sm" (click)="selecttobill()"
                            *ngIf="fp.csgversendtobill && activeTab == 'CSGVerification' && fromClaim.from != 'Claim'"
                            [disabled]="sendToBillinProgress || selectedcsgs?.length==0 || global.checkProgressCSG">Send
                            To Bill
                        </button>
                        <button type="button" [disabled]="sendToBillinProgress" *ngIf="fromClaim.from == 'Claim'"
                            class="btn btn-sm ms-2" (click)="updateClaim()">Update Claim</button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <nav *ngIf="!global.docbool">
                                <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                    <a *ngIf="showTimesheetTab" class="nav-item nav-link active" [ngClass]="{'mytab-inactive':
                                                    activeTab!='TimesheetVerification',
                                                    'active': activeTab=='TimesheetVerification'}"
                                        id="nav-TimesheetVerification-tab" data-bs-toggle="tab"
                                        href="#nav-TimesheetVerification" role="tab"
                                        aria-controls="nav-TimesheetVerification" aria-selected="true"
                                        (click)="getActiveTab('TimesheetVerification')">Timesheet</a>
                                    <a *ngIf="showTransactionTab" class="nav-item nav-link" [ngClass]="{'mytab-inactive':
                                                activeTab!='TransactionVerification',
                                                    'active':activeTab=='TransactionVerification' }"
                                        id="nav-TransactionVerification-tab" data-bs-toggle="tab"
                                        href="#nav-TransactionVerification" role="tab" aria-controls="nav-active"
                                        aria-selected="true"
                                        (click)="getActiveTab('TransactionVerification')">Transaction</a>
                                    <a *ngIf="showPurchaseTab" class="nav-item nav-link" [ngClass]="{'mytab-inactive':
                                                    activeTab!='PurchseVerification',
                                                        'active': activeTab=='PurchseVerification'}"
                                        id="nav-PurchseVerification-tab" data-bs-toggle="tab"
                                        href="#nav-PurchseVerification" role="tab"
                                        aria-controls="nav-PurchseVerification" aria-selected="true"
                                        (click)="getActiveTab('PurchseVerification')">Purchase</a>
                                    <a *ngIf="showCSGTab" class="nav-item nav-link" [ngClass]="{'mytab-inactive':
                                                    activeTab!='CSGVerification',
                                                        'active': activeTab=='CSGVerification'}"
                                        id="nav-CSGVerification-tab" data-bs-toggle="tab" href="#nav-CSGVerification"
                                        role="tab" aria-controls="nav-CSGVerification" aria-selected="true"
                                        (click)="getActiveTab('CSGVerification')">CSG</a>
                                </div>
                            </nav>
                            <div class="tab-content" id="nav-tabContent">
                                <div class="tab-pane fade show active" id="nav-unlocked" role="tabpanel"
                                    aria-labelledby="nav-unlocked-tab" [ngClass]="{
                                        active: activeTab == 'TimesheetVerification',
                                        show: activeTab == 'TimesheetVerification'
                                      }">
                                    <ejs-grid #gridTimesheetV [dataSource]='GridTimesheetVList | async'
                                        [allowResizing]='true' [allowSorting]='true' [allowPaging]='true'
                                        [allowFiltering]='true' [showColumnChooser]='true' [pageSettings]='initialPage'
                                        (checkBoxChange)="CheckBoxClickEvent($event)" [filterSettings]='filterOptions'
                                        [selectionSettings]='selectionOptions' (cellEdit)="cellEdit($event)"
                                        (rowDataBound)='rowDataBound($event)' [textWrapSettings]='wrapSettings'
                                        (dataStateChange)='dataStateChange($event)'
                                        (actionBegin)="onActionComplete($event)"
                                        (queryCellInfo)='validatebutton($event)'>
                                        <e-columns>
                                            <e-column type='checkbox' [showInColumnChooser]='false' uid="checkbox"
                                                maxWidth=80 [allowEditing]='true' editType="booleanedit"
                                                [edit]='checkparams' textAlign='center'></e-column>
                                            <!-- <e-column field='claimStatus' headerText="Claim Status" textAlign='center'
                                                minWidth=80 [allowEditing]='false' type='string'
                                                [allowFiltering]="false">
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column> -->
                                            <e-column field='validate' headerText="Validate" minWidth=80
                                                textAlign='center' [allowEditing]='false' [allowFiltering]="false"
                                                [allowSorting]='false'>
                                                <ng-template #template let-data>
                                                    <div>
                                                        <button class="" data-bs-toggle="modal"
                                                            data-bs-target="#showerror"
                                                            (click)="showerrors($event)">Validate</button>
                                                    </div>
                                                </ng-template>
                                            </e-column>


                                            <e-column field='client_Name' headerText="Client Name" textAlign='center'
                                                minWidth='80' type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <e-column field='employee_Name' headerText="Employee Name"
                                                textAlign='center' minWidth='80' type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <e-column field='payer_PayorName' headerText="Payer Name" textAlign='center'
                                                minWidth=80 type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <e-column field='serviceCodeToDisplay' headerText="Service Name"
                                                textAlign='center' minWidth=80 type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>

                                            <e-column field='timesheetDate' headerText="Timesheet Date" minWidth='80' [allowFiltering]="false"
                                                textAlign='center' [format]='formatOptions'
                                                type='date'>
                                            </e-column>
                                            <e-column field='payrate' headerText="Pay Rate" textAlign='center'
                                                minWidth=80  type='number'>
                                                <!-- <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template> -->
                                            </e-column>

                                            <e-column field='hours' headerText="Total Hours" minWidth=80
                                                textAlign='center' type='number'>
                                                <!-- <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template> -->
                                            </e-column>
                                             <e-column field='overTimeHours' headerText="Over Time Hours" minWidth=80 [allowEditing]="false" [allowFiltering]="false" [allowSorting] = "false"
                                                textAlign='center'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>

                                            <e-column field='totalAmount' headerText="Total Amount" minWidth=80 [allowEditing]="false"
                                                textAlign='center' type='number'></e-column>

                                            
                                                
                                            <e-column field='timesheetNotes' headerText="Timesheet Notes" minWidth=80 [allowSorting]="false"  [allowFiltering]="false" [allowEditing]="false"
                                                textAlign='center'>
                                            </e-column>
                                            <e-column field='isVisitApproved' headerText="Is Visit Approved" minWidth=80 [allowFiltering]="false" [allowSorting]="false"
                                                textAlign='center' >
                                                <ng-template #template let-data>
                                                    <i class="fa fa-times" *ngIf='data.isVisitApproved==false' 
                                                            style="font-size:27px;color:red"></i>
                                                    <i class="fa fa-check" *ngIf='data.isVisitApproved==true'
                                                        style="font-size:27px;color:green"></i>
                                                        
                                                   
                                                </ng-template>
                                            </e-column>
                                            <e-column width="50" [showInColumnChooser]='false'>
                                                <ng-template #headerTemplate let-data>
                                                    <div>
                                                        <span id='show' (click)='showTimesheetColumns()'><i
                                                                class="fa fa-cog fa-lg" aria-hidden="true">
                                                            </i></span>
                                                    </div>
                                                </ng-template>
                                            </e-column>

                                        </e-columns>
                                    </ejs-grid>
                                </div>
                                <div class="tab-pane fade show active" id="nav-unlocked" role="tabpanel"
                                    aria-labelledby="nav-unlocked-tab" [ngClass]="{
                                        active: activeTab == 'TransactionVerification',
                                        show: activeTab == 'TransactionVerification'
                                      }">
                                    <ejs-grid #gridTransactionV [dataSource]='GridTransactionVList | async'
                                        [allowResizing]='true' [allowSorting]='true' [allowPaging]='true'
                                        [allowFiltering]='true' [showColumnChooser]='true' [pageSettings]='initialPage'
                                        (checkBoxChange)="CheckBoxClickEvent($event)" [filterSettings]='filterOptions'
                                        [selectionSettings]='selectionOptions' (cellEdit)="cellEdit($event)"
                                        (rowDataBound)='rowDataBound($event)' [textWrapSettings]='wrapSettings'
                                        (dataStateChange)='dataStateChange($event)'
                                        (actionBegin)="onActionComplete($event)"
                                        (queryCellInfo)='validatebutton($event)'>

                                        <e-columns>
                                            <e-column type='checkbox' [showInColumnChooser]='false' uid="checkbox"
                                                maxWidth=80 [allowEditing]='true' editType="booleanedit"
                                                [edit]='checkparams' textAlign='center'></e-column>
                                            <!-- <e-column field='claimStatus' headerText="Claim Status" textAlign='center'
                                                minWidth=80 [allowEditing]='false' type='string'
                                                [allowFiltering]="false">
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column> -->
                                            <e-column field='validate' headerText="Validate" minWidth=80
                                                textAlign='center' [allowEditing]='false' [allowFiltering]="false"
                                                [allowSorting]='false'>
                                                <ng-template #template let-data>
                                                    <div>
                                                        <button class="" data-bs-toggle="modal"
                                                            data-bs-target="#showerror"
                                                            (click)="showerrors($event)">Validate</button>

                                                    </div>
                                                </ng-template>
                                            </e-column>

                                            <e-column field='client_Name' headerText="Client Name" textAlign='center'
                                                minWidth='80' type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>

                                            <e-column field='payer_PayorName' headerText="Payer Name" textAlign='center'
                                                minWidth=80 type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <e-column field='serviceCodeToDisplay' headerText="Service Name"
                                                textAlign='center' minWidth=80 type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <e-column minWidth=80 field="taxName" headerText="Tax Name" type="string">
                                                <ng-template #filterTemplate let-data>
                                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                              </e-column>

                                            <e-column field='transactionDate' headerText="Transaction Date"  [allowFiltering]="false"
                                                minWidth='80' textAlign='center' [format]='formatOptions' type='date'>
                                            </e-column>


                                            <e-column field='totalAmount' headerText="Total Amount" minWidth=80 [allowEditing]="false"
                                                textAlign='center'
                                                type='number'></e-column>
 <e-column field='isVisitApproved' headerText="Is Approved" minWidth=80 [allowFiltering]="false" [allowSorting]="false"
                                                textAlign='center' >
                                                <ng-template #template let-data>
                                                    <i class="fa fa-times" *ngIf='data.isVisitApproved==false' 
                                                            style="font-size:27px;color:red"></i>
                                                    <i class="fa fa-check" *ngIf='data.isVisitApproved==true'
                                                        style="font-size:27px;color:green"></i>
                                                        
                                                   
                                                </ng-template>
                                            </e-column>
                                                 <!-- <e-column minWidth=100 field="exceedAmount" headerText="Exceed Amount" type="number">
                                                    <ng-template #filterTemplate let-data>
                                                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                                    </ng-template>
                                                </e-column>  -->
                                            <e-column width="50" [showInColumnChooser]='false'>
                                                <ng-template #headerTemplate let-data>
                                                    <div>
                                                        <span id='show' (click)='showTimesheetColumns()'><i
                                                                class="fa fa-cog fa-lg" aria-hidden="true">
                                                            </i></span>
                                                    </div>
                                                </ng-template>
                                            </e-column>

                                        </e-columns>
                                    </ejs-grid>
                                </div>
                                <div class="tab-pane fade show active" id="nav-unlocked" role="tabpanel"
                                    aria-labelledby="nav-unlocked-tab" [ngClass]="{
                                        active: activeTab == 'PurchseVerification',
                                        show: activeTab == 'PurchseVerification'
                                      }">
                                    <ejs-grid #gridPurchaseV [dataSource]='GridPurchaseVList | async'
                                        [allowResizing]='true' [allowSorting]='true' [allowPaging]='true'
                                        [allowFiltering]='true' [showColumnChooser]='true' [pageSettings]='initialPage'
                                        (checkBoxChange)="CheckBoxClickEvent($event)" [filterSettings]='filterOptions'
                                        [selectionSettings]='selectionOptions' (cellEdit)="cellEdit($event)"
                                        (rowDataBound)='rowDataBound($event)' [textWrapSettings]='wrapSettings'
                                        (dataStateChange)='dataStateChange($event)'
                                        (actionBegin)="onActionComplete($event)"
                                        (queryCellInfo)='validatebutton($event)'>
                                        <!-- 
                                            (toolbarclick)="getdata($event)" (resizeStop)="onResize($event)"-->
                                        <e-columns>
                                            <e-column type='checkbox' [showInColumnChooser]='false' maxWidth=80
                                                [allowEditing]='true' [edit]='checkparams'
                                                textAlign='center'></e-column>
                                            <!-- <e-column field='claimStatus' headerText="Claim Status" textAlign='center'
                                                minWidth=80 [allowEditing]='false' type='string'
                                                [allowFiltering]="false">
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column> -->
                                            <e-column field='validate' headerText="Validate" minWidth=80
                                                textAlign='center' [allowEditing]='false' [allowFiltering]="false"
                                                [allowSorting]='false'>
                                                <ng-template #template let-data>
                                                    <div>
                                                        <button class="" data-bs-toggle="modal"
                                                            data-bs-target="#showerror"
                                                            (click)="showerrors($event)">Validate</button>
                                                    </div>
                                                </ng-template>
                                            </e-column>

                                            <e-column field='client_Name' headerText="Client Name" textAlign='center'
                                                minWidth='80' [allowEditing]='false' type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>

                                            <e-column field='payer_PayorName' headerText="Payer Name" textAlign='center'
                                                minWidth=80 [allowEditing]='false' type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <e-column field='serviceCodeToDisplay' headerText="Service Name"
                                                textAlign='center' minWidth=80 [allowEditing]='false' type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>

                                            <e-column field='purchaseRequestDate' headerText="Purchase Date" [allowFiltering]="false"
                                                minWidth='80' textAlign='center' [format]='formatOptions'
                                                type='date'>
                                            </e-column>
                                            <e-column field='payrate' headerText="Pay Rate" textAlign='center' minWidth=80
                                                 type='number'>
                                                <!-- <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template> -->
                                            </e-column>

                                            <e-column field='quantity' headerText="Quantity" minWidth=80
                                                textAlign='center' type='number'>
                                                <!-- <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template> -->
                                            </e-column>

                                            <e-column field='totalAmount' headerText="Total Amount" minWidth=80
                                                textAlign='center' [allowEditing]="false"
                                                type='number'></e-column>
 <e-column field='isVisitApproved' headerText="Is Approved" minWidth=80 [allowFiltering]="false" [allowSorting]="false"
                                                textAlign='center' >
                                                <ng-template #template let-data>
                                                    <i class="fa fa-times" *ngIf='data.isVisitApproved==false' 
                                                            style="font-size:27px;color:red"></i>
                                                    <i class="fa fa-check" *ngIf='data.isVisitApproved==true'
                                                        style="font-size:27px;color:green"></i>
                                                        
                                                   
                                                </ng-template>
                                            </e-column>

                                            <e-column width="50" [showInColumnChooser]='false'>
                                                <ng-template #headerTemplate let-data>
                                                    <div>
                                                        <span id='show' (click)='showTimesheetColumns()'><i
                                                                class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                                                    </div>
                                                </ng-template>
                                            </e-column>

                                        </e-columns>
                                    </ejs-grid>
                                </div>
                                <div class="tab-pane fade show active" id="nav-unlocked" role="tabpanel"
                                    aria-labelledby="nav-unlocked-tab" [ngClass]="{
                                        active: activeTab == 'CSGVerification',
                                        show: activeTab == 'CSGVerification'
                                      }">
                                    <ejs-grid #gridCSGV [dataSource]='GridCSGVList | async' [allowResizing]='true'
                                        [allowSorting]='true' [allowPaging]='true' [allowFiltering]='true'
                                        [showColumnChooser]='true' [pageSettings]='initialPage'
                                        (checkBoxChange)="CheckBoxClickEvent($event)" [filterSettings]='filterOptions'
                                        [selectionSettings]='selectionOptions' (cellEdit)="cellEdit($event)"
                                        (rowDataBound)='rowDataBound($event)' [textWrapSettings]='wrapSettings'
                                        (dataStateChange)='dataStateChange($event)'
                                        (actionBegin)="onActionComplete($event)"
                                        (queryCellInfo)='validatebutton($event)'>
                                        <e-columns>
                                            <e-column type='checkbox' [showInColumnChooser]='false' uid="checkbox"
                                                maxWidth=80 [allowEditing]='true' editType="booleanedit"
                                                [edit]='checkparams' textAlign='center'></e-column>
                                            <!-- <e-column field='claimStatus' headerText="Claim Status" textAlign='center'
                                                minWidth=80 [allowEditing]='false' type='string'
                                                [allowFiltering]="false">
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column> -->
                                            <e-column field='validate' headerText="Validate" minWidth=80
                                                textAlign='center' [allowEditing]='false' [allowFiltering]="false"
                                                [allowSorting]='false'>
                                                <ng-template #template let-data>
                                                    <div>
                                                        <button class="" data-bs-toggle="modal"
                                                            data-bs-target="#showerror"
                                                            (click)="showerrors($event)">Validate</button>
                                                    </div>
                                                </ng-template>
                                            </e-column>
                                            <e-column field='claimType' headerText="Claim Type" minWidth=80
                                                textAlign='center'
                                                type='string'></e-column>

                                            <e-column field='client_Name' headerText="Client Name" textAlign='center'
                                                minWidth='80' type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <e-column field='employee_Name' headerText="Employee Name"
                                                textAlign='center' minWidth='80' type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <e-column field='payer_PayorName' headerText="Payer Name" textAlign='center'
                                                minWidth=80  type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <e-column field='serviceCodeToDisplay' headerText="Service Name"
                                                textAlign='center' minWidth=80 type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>

                                            <e-column field='createdDate' headerText="Service Date" minWidth='80' [allowFiltering]="false"
                                                textAlign='center' [format]='formatOptions'
                                                type='date'>
                                            </e-column>
                                            <e-column field='payrate' headerText="Pay Rate" textAlign='center'
                                                minWidth=80 type='number'>
                                                <!-- <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template> -->
                                            </e-column>

                                            <e-column field='hours' headerText="Total Hours" minWidth=80
                                                textAlign='center' type='number'>
                                                <!-- <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template> -->
                                            </e-column>

                                            <e-column field='totalAmount' headerText="Total Amount" minWidth=80
                                                textAlign='center' [allowEditing]="false"
                                                type='number'></e-column>


                                            <e-column field='timesheetNotes' headerText="Timesheet Notes" minWidth=80
                                                textAlign='center' [allowSorting]="false"  [allowFiltering]="false" [allowEditing]="false"
                                                type='date'>
                                            </e-column>

 <e-column field='isVisitApproved' headerText="Is Approved" minWidth=80 [allowFiltering]="false" [allowSorting]="false"
                                                textAlign='center' >
                                                <ng-template #template let-data>
                                                    <i class="fa fa-times" *ngIf='data.isVisitApproved==false' 
                                                            style="font-size:27px;color:red"></i>
                                                    <i class="fa fa-check" *ngIf='data.isVisitApproved==true'
                                                        style="font-size:27px;color:green"></i>
                                                        
                                                   
                                                </ng-template>
                                            </e-column>

                                            <e-column width="50" [showInColumnChooser]='false'>
                                                <ng-template #headerTemplate let-data>
                                                    <div>
                                                        <span id='show' (click)='showTimesheetColumns()'><i
                                                                class="fa fa-cog fa-lg" aria-hidden="true">
                                                            </i></span>
                                                    </div>
                                                </ng-template>
                                            </e-column>

                                        </e-columns>
                                    </ejs-grid>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>

<span id="OpenModal2" data-bs-target="#showerror" data-bs-toggle="modal"></span>
<div class="modal fade" id="showerror" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" style="width:700px;">
            <div class="modal-header">
                <label class="font-header fs-5">Check Validation Status</label>
                <button class="btn-close" type="button" data-bs-dismiss="modal" (click)="colseerr()"></button>
            </div>
            <div class="modal-body">
                <div class="container scrolltbody">
                    <div class="mb-2 d-flex ms-4 ps-3">
                        <input type="checkbox" class="mr-2 mt-1" [(ngModel)]="isEnabled" (change)="SelectErrorData()" />

                        <label for="radio-1" class="mt-1 d-flex ms-2" [class.textcolor]="isEnabled">Show errors
                            only</label>
                    </div>
                    <div class="d-flex justify-content-center">
                        <table class="table table-responsive table-hover table-bordered ms-0" style="width:600px;">
                            <thead style="background: #502189;height: 25px;">

                                <th style="width: 200px;font-size:15px;" class="pointer text-center">Column</th>
                                <th style="width: 150px;font-size:15px;" class="pointer text-center">Status</th>

                            </thead>
                            <tbody>
                                <tr *ngFor="let c of showerrorlist1" class="row1">

                                    <td [style.color]="c.color" class="row1 font-weight textSize">
                                        {{c.columnName}} </td>

                                    <td [style.color]="c.colr" class="text-center textSize">{{c.status}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-sm  text-right" type="button" (click)="colseerr()">
                    Close</button>
            </div>
        </div>
    </div>
</div>
